import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-3699529e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "microvideo-container"
};
var _hoisted_2 = {
  key: 0,
  class: "video-not-open-text"
};
var _hoisted_3 = {
  key: 1,
  class: "video-not-open-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.envCheckService.videoAndAudioErrorResult ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.envCheckService.videoAndAudioErrorResult), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_3, "摄像头未打开")), _createElementVNode("video", {
    class: _normalizeClass(["video-monitor", {
      playing: _ctx.stream && !_ctx.microError
    }]),
    ref: "microVideoRef",
    controls: "",
    autoplay: "",
    playsinline: "",
    muted: ""
  }, null, 2)]);
}